module.exports = __webpack_public_path__ + "static/media/cookie.fe84a727.svg";